import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SuperAdminServices from '../../services/SuperAdminServices';

const initialState = {
	users: [],
	claims: [],
	listCompanies: [],
	allCompanies: [],
	clients: [],
	parrainages: [],
	contenaires: [],
	allContenaires: [],
	loading: false,
	error: null,
	financements: [],
	financementDetails: null,
	financementStats: null,
	errorMessage: null,
	isSuccess: false,
	totalPaid: 0,
	totalUnpaid: 0,
	list: [],
	claimsList: [],
	checkedList: [],
	badCredentials: null,
	total: 0,
	totalAmount: 0,
};

//---------------------------------------------- SUPER-ADMIN users features -----------------------------------------------------------//
export const usersList = createAsyncThunk(
	'/admins',
	async ({ token, page, search, company }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getAdminsList(page, token, search, company);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const toggleParrainageStatus = createAsyncThunk(
	'superadmin/toggleParrainageStatus',
	async ({ token, id }, thunkApi) => {
		try {
			const res = await SuperAdminServices.toggleParrainageStatus(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

//---------------------------------------------- SUPER-ADMIN Financements -----------------------------------------------------------//
export const getAllFinancementsSA = createAsyncThunk(
	'superadmin/getAllFinancementsSA',
	async ({ token, page, status, company, search }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getAllFinancementsSA(
				token,
				page,
				status,
				company,
				search,
			);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getFinancementDetailsSA = createAsyncThunk(
	'superadmin/getFinancementDetailsSA',
	async ({ token, id }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getFinancementDetailsSA(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const updateFinancementSA = createAsyncThunk(
	'superadmin/updateFinancementSA',
	async ({ token, id, data }, thunkApi) => {
		try {
			const res = await SuperAdminServices.updateFinancementSA(token, id, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const deleteFinancementSA = createAsyncThunk(
	'superadmin/deleteFinancementSA',
	async ({ token, id }, thunkApi) => {
		try {
			const res = await SuperAdminServices.deleteFinancementSA(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const newAdmin = createAsyncThunk('/new_admin', async ({ token, data }, thunkApi) => {
	try {
		const res = await SuperAdminServices.createAdmin(token, data);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

export const getClientsList = createAsyncThunk(
	'superadmin/getClientsList',
	async ({ token, page, search, type, company }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getClients(token, page, search, type, company);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

//---------------------------------------------- SUPER-ADMIN Parrainage -----------------------------------------------------------//
export const getParrainageList = createAsyncThunk(
	'superadmin/getParrainageList',
	async ({ token, page, beneficiaryCompany, sponsorCompany }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getParrainageList(
				token,
				page,
				beneficiaryCompany,
				sponsorCompany,
			);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

//---------------------------------------------- SUPER-ADMIN Contenaire -----------------------------------------------------------//
export const createContenaire = createAsyncThunk(
	'superadmin/createContenaire',
	async ({ token, data }, thunkApi) => {
		try {
			const res = await SuperAdminServices.createContenaire(token, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getContenairesList = createAsyncThunk(
	'superadmin/getContenairesList',
	async ({ token, page, search }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getContenairesList(token, page, search);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getAllContenairesList = createAsyncThunk(
	'superadmin/getAllContenairesList',
	async ({ token }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getAllContenairesList(token);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getContenaireById = createAsyncThunk(
	'superadmin/getContenaireById',
	async ({ token, id }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getContenaireById(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const updateContenaire = createAsyncThunk(
	'superadmin/updateContenaire',
	async ({ token, id, data }, thunkApi) => {
		try {
			const res = await SuperAdminServices.updateContenaire(token, id, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const deleteContenaire = createAsyncThunk(
	'superadmin/deleteContenaire',
	async ({ token, id }, thunkApi) => {
		try {
			const res = await SuperAdminServices.deleteContenaire(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const deleteMultipleContenaires = createAsyncThunk(
	'superadmin/deleteMultipleContenaires',
	async ({ token, ids }, thunkApi) => {
		try {
			const res = await SuperAdminServices.deleteMultipleContenaires(token, ids);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

//---------------------------------------------- SUPER-ADMIN Admin features -----------------------------------------------------------//
export const adminBlocked = createAsyncThunk(
	'/admin_blocked',
	async ({ token, id, data }, thunkApi) => {
		try {
			const res = await SuperAdminServices.blockAdmin(token, id, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const update_Admin = createAsyncThunk(
	'/updateadmin',
	async ({ token, id, data }, thunkApi) => {
		try {
			const res = await SuperAdminServices.updateAdmin(token, id, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const search_admin_name = createAsyncThunk(
	'/searchname',
	async ({ token, name }, thunkApi) => {
		try {
			const res = await SuperAdminServices.searchAdmin(token, name);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

//---------------------------------------------- SUPER-ADMIN claims -----------------------------------------------------------//
export const search_admin_claim = createAsyncThunk(
	'/searchclaim',
	async ({ token, value, page, status }, thunkApi) => {
		try {
			const res = await SuperAdminServices.searchClaim(token, value, page, status);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const claimList = createAsyncThunk('claimslist', async ({ token, page }, thunkApi) => {
	try {
		const res = await SuperAdminServices.getClaimsList(token, page);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

//---------------------------------------------- SUPER-ADMIN Companies -----------------------------------------------------------//
export const companiesList = createAsyncThunk(
	'/companies',
	async ({ token, page, search }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getCompaniesList(page, token, search);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const companiesForAdmins = createAsyncThunk(
	'/companiesForAdmins',
	async ({ token }, thunkApi) => {
		try {
			const res = await SuperAdminServices.getCompaniesForAdmins(token);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const newCompany = createAsyncThunk('/new_company', async ({ token, data }, thunkApi) => {
	try {
		const res = await SuperAdminServices.createCompany(token, data);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

export const updateCompanyAction = createAsyncThunk(
	'/update_company',
	async ({ token, id, data }, thunkApi) => {
		try {
			const res = await SuperAdminServices.updateCompany(token, id, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const deleteCompanyAction = createAsyncThunk(
	'/delete_company',
	async ({ token, id }, thunkApi) => {
		try {
			const res = await SuperAdminServices.deleteCompany(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

//------------------------------------  Main feature -----------------------------------//
const superAdminSlice = createSlice({
	name: 'superAdmin',
	initialState,
	reducers: {
		clearState: (state) => {
			state.loading = false;
			state.users = [];
			state.error = [];
			state.listCompanies = [];
			state.errorMessage = [];
			state.list = [];
			state.badCredentials = [];
			state.isSuccess = [];
			state.claims = [];
			state.claimsList = [];
			state.clients = [];
			state.parrainages = [];
			state.contenaires = [];
			state.allContenaires = [];
			state.financements = [];
			state.financementDetails = null;
			state.financementStats = null;
			state.totalAmount = 0;
		},
		clearCheckList: (state) => {
			state.checkedList = [];
		},
		setCheckedList: (state, action) => {
			const itemId = action.payload._id;
			if (!state.checkedList.some((item) => item._id === itemId)) {
				return {
					...state,
					checkedList: [...state.checkedList, action.payload],
				};
			}
			return state;
		},
		setUnCheckedList: (state, action) => {
			state.checkedList = state.checkedList.filter((el) => el._id !== action.payload._id);
		},
	},
	extraReducers: (builder) => {
		builder
			// Users List
			.addCase(usersList.pending, (state) => {
				state.loading = true;
			})
			.addCase(usersList.fulfilled, (state, action) => {
				state.users = action.payload;
				state.error = false;
				state.list = action.payload.data?.list || [];
				state.total = action.payload.total;
				state.isSuccess = action.payload.success;
				state.loading = false;
			})
			.addCase(usersList.rejected, (state, { payload }) => {
				state.error = true;
				state.errorMessage = payload;
				state.loading = false;
				state.isSuccess = false;
			})
			.addCase(getClientsList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getClientsList.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.clients = action.payload.data?.list || [];
				state.list = action.payload.data?.list || [];
				state.total = action.payload.data?.total || 0;
				state.isSuccess = true;
			})
			.addCase(getClientsList.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du chargement des clients';
				state.isSuccess = false;
				state.clients = [];
				state.list = [];
			})
			.addCase(getParrainageList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getParrainageList.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.parrainages = action.payload.data?.list || [];
				state.list = action.payload.data?.list || [];
				state.total = action.payload.data?.pagination?.totalItems || 0;
				state.totalPaid = action.payload.data?.totalPaid || 0;
				state.totalUnpaid = action.payload.data?.totalUnpaid || 0;
				state.totalAmount = action.payload.data?.totalAmount || 0;
				state.isSuccess = true;
			})
			.addCase(getParrainageList.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du chargement des parrainages';
				state.isSuccess = false;
				state.parrainages = [];
				state.list = [];
				state.totalAmount = 0;
			})
			.addCase(toggleParrainageStatus.pending, (state) => {
				state.loading = true;
			})
			.addCase(toggleParrainageStatus.fulfilled, (state, action) => {
				state.loading = false;
				state.isSuccess = true;
				const updatedParrainage = action.payload.data;
				const index = state.parrainages.findIndex((p) => p._id === updatedParrainage._id);
				if (index !== -1) {
					state.parrainages[index] = updatedParrainage;
				}
			})
			.addCase(toggleParrainageStatus.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du changement de statut';
				state.isSuccess = false;
			})
			// Contenaire - Create
			.addCase(createContenaire.pending, (state) => {
				state.loading = true;
			})
			.addCase(createContenaire.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.isSuccess = true;
				state.contenaires.push(action.payload.data);
			})
			.addCase(createContenaire.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors de la création';
				state.isSuccess = false;
			})
			// Contenaire - Get List
			.addCase(getContenairesList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getContenairesList.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.contenaires = action.payload.data || [];
				state.list = action.payload.data || [];
				state.total = action.payload.total || 0;
				state.isSuccess = true;
			})
			.addCase(getContenairesList.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du chargement';
				state.isSuccess = false;
				state.contenaires = [];
			})
			// Contenaire - Get All (no pagination)
			.addCase(getAllContenairesList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllContenairesList.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.allContenaires = action.payload.data || [];
				state.isSuccess = true;
			})
			.addCase(getAllContenairesList.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du chargement';
				state.isSuccess = false;
				state.allContenaires = [];
			})
			// Contenaire - Get By ID
			.addCase(getContenaireById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getContenaireById.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.contenaireDetails = action.payload.data || null;
				state.isSuccess = true;
			})
			.addCase(getContenaireById.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du chargement';
				state.isSuccess = false;
				state.contenaireDetails = null;
			})
			// Contenaire - Update
			.addCase(updateContenaire.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateContenaire.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.isSuccess = true;
				const updatedContenaire = action.payload.data;
				const index = state.contenaires.findIndex((c) => c._id === updatedContenaire._id);
				if (index !== -1) {
					state.contenaires[index] = updatedContenaire;
				}
			})
			.addCase(updateContenaire.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors de la mise à jour';
				state.isSuccess = false;
			})
			// Contenaire - Delete
			.addCase(deleteContenaire.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteContenaire.fulfilled, (state, { meta }) => {
				state.loading = false;
				state.error = false;
				state.isSuccess = true;
				state.contenaires = state.contenaires.filter((c) => c._id !== meta.arg.id);
				state.total = state.total - 1;
			})
			.addCase(deleteContenaire.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors de la suppression';
				state.isSuccess = false;
			})
			// Contenaire - Delete Multiple
			.addCase(deleteMultipleContenaires.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteMultipleContenaires.fulfilled, (state, { meta }) => {
				state.loading = false;
				state.error = false;
				state.isSuccess = true;
				const deletedIds = meta.arg.ids;
				state.contenaires = state.contenaires.filter((c) => !deletedIds.includes(c._id));
				state.total = state.total - deletedIds.length;
			})
			.addCase(deleteMultipleContenaires.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors de la suppression';
				state.isSuccess = false;
			})
			.addCase(newAdmin.pending, (state) => {
				state.loading = true;
				state.error = false;
			})
			.addCase(newAdmin.fulfilled, (state, action) => {
				state.users = { ...state.users, ...action.payload };
				state.error = false;
				state.loading = false;
				state.addSuccess = true;
			})
			.addCase(newAdmin.rejected, (state, { payload }) => {
				state.error = true;
				state.loading = false;
				state.isSuccess = false;
			})
			.addCase(adminBlocked.pending, (state) => {
				state.loading = true;
			})
			.addCase(adminBlocked.fulfilled, (state, action) => {
				state.users = action.payload;
				state.error = false;
				state.isSuccess = action.payload.success;
				state.loading = false;
			})
			.addCase(adminBlocked.rejected, (state, { payload }) => {
				state.error = true;
				state.errorMessage = payload;
				state.loading = false;
				state.isSuccess = false;
			})
			.addCase(update_Admin.pending, (state) => {
				state.loading = true;
			})
			.addCase(update_Admin.fulfilled, (state, action) => {
				state.users = { ...state.users, ...action.payload };
				state.error = false;
				state.isSuccess = action.payload.success;
				state.loading = false;
			})
			.addCase(update_Admin.rejected, (state, { payload }) => {
				state.error = true;
				state.errorMessage = payload;
				state.loading = false;
				state.isSuccess = false;
			})
			.addCase(search_admin_name.pending, (state) => {
				state.loading = true;
			})
			.addCase(search_admin_name.fulfilled, (state, action) => {
				state.users = action.payload;
				state.error = false;
				state.list = action.payload.data;
				state.isSuccess = action.payload.success;
				state.loading = false;
			})
			.addCase(search_admin_name.rejected, (state, { payload }) => {
				state.error = true;
				state.errorMessage = payload.message;
				state.loading = false;
				state.isSuccess = false;
			})
			.addCase(claimList.pending, (state) => {
				state.loading = true;
			})
			.addCase(claimList.fulfilled, (state, action) => {
				state.claims = action.payload;
				state.error = false;
				state.claimsList = action.payload.data;
				state.isSuccess = action.payload.success;
				state.loading = false;
			})
			.addCase(claimList.rejected, (state, { payload }) => {
				state.error = true;
				state.errorMessage = payload.message;
				state.loading = false;
				state.isSuccess = false;
			})
			.addCase(search_admin_claim.pending, (state) => {
				state.loading = true;
			})
			.addCase(search_admin_claim.fulfilled, (state, action) => {
				state.claims = action.payload.data;
				state.claimsList = action.payload.data;
				state.total = action.payload.total;
				state.error = false;
				state.loading = false;
				state.isSuccess = true;
			})
			.addCase(search_admin_claim.rejected, (state, { payload }) => {
				state.error = true;
				state.errorMessage = payload.message;
				state.loading = false;
				state.isSuccess = false;
			})
			.addCase(companiesList.pending, (state) => {
				state.loading = true;
			})
			.addCase(companiesList.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.listCompanies = action.payload.data;
				state.total = action.payload.total;
				state.isSuccess = action.payload.success;
			})
			.addCase(companiesList.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload.message;
				state.isSuccess = false;
			})
			.addCase(newCompany.pending, (state) => {
				state.loading = true;
			})
			.addCase(newCompany.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.isSuccess = true;
				state.listCompanies.push(action.payload.data);
			})
			.addCase(newCompany.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload;
				state.isSuccess = false;
			})
			.addCase(updateCompanyAction.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateCompanyAction.fulfilled, (state) => {
				state.loading = false;
				state.error = false;
				state.isSuccess = true;
			})
			.addCase(updateCompanyAction.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload;
				state.isSuccess = false;
			})
			.addCase(deleteCompanyAction.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteCompanyAction.fulfilled, (state) => {
				state.loading = false;
				state.error = false;
				state.isSuccess = true;
			})
			.addCase(deleteCompanyAction.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload;
				state.isSuccess = false;
			})
			.addCase(companiesForAdmins.pending, (state) => {
				state.loading = true;
			})
			.addCase(companiesForAdmins.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.allCompanies = action.payload.data || [];
			})
			.addCase(companiesForAdmins.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload;
				state.allCompanies = [];
			})
			.addCase(getAllFinancementsSA.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllFinancementsSA.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.financements = action.payload.data?.list || [];
				state.list = action.payload.data?.list || [];
				state.total = action.payload.data?.pagination?.totalItems || 0;
				state.financementStats = action.payload.data?.stats || null;
				state.isSuccess = true;
			})
			.addCase(getAllFinancementsSA.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du chargement des financements';
				state.isSuccess = false;
				state.financements = [];
				state.list = [];
				state.financementStats = null;
			})
			.addCase(getFinancementDetailsSA.pending, (state) => {
				state.loading = true;
			})
			.addCase(getFinancementDetailsSA.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.financementDetails = action.payload.data || null;
				state.isSuccess = true;
			})
			.addCase(getFinancementDetailsSA.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors du chargement des détails';
				state.isSuccess = false;
				state.financementDetails = null;
			})
			.addCase(updateFinancementSA.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateFinancementSA.fulfilled, (state, action) => {
				state.loading = false;
				state.isSuccess = true;
				const index = state.financements.findIndex((f) => f._id === action.payload.data._id);
				if (index !== -1) {
					state.financements[index] = action.payload.data;
				}
			})
			.addCase(updateFinancementSA.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors de la mise à jour';
				state.isSuccess = false;
			})
			.addCase(deleteFinancementSA.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteFinancementSA.fulfilled, (state, { meta }) => {
				state.loading = false;
				state.isSuccess = true;
				state.financements = state.financements.filter((f) => f._id !== meta.arg.id);
				state.total = state.total - 1;
			})
			.addCase(deleteFinancementSA.rejected, (state, { payload }) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = payload?.message || 'Erreur lors de la suppression';
				state.isSuccess = false;
			});
	},
});

export default superAdminSlice.reducer;
export const { setCheckedList, setUnCheckedList, clearCheckList, clearState } =
	superAdminSlice.actions;